// test2612
(2612 && 0);
